export const MASTER_MENU_TYPES = {
  CM: {
    name: "Customers",
    subTypes: [
      { name: "sales", display_name: "Sales" },
      { name: "job work", display_name: "Job Work" },
      { name: "prototype", display_name: "Prototype/Sampling" },
    ],
  },
  VM: {
    name: "Sourcing",
    subTypes: [
      { name: "vendors", display_name: "Vendors" },
      { name: "suppliers", display_name: "Suppliers" },
    ],
  },
  PM: {
    name: "Product Master",
    subTypes: [
      { name: "sales", display_name: "Sales" },
      { name: "job work", display_name: "Job Work" },
      { name: "prototype", display_name: "Prototype/Sampling" },
    ],
  },
};

export const formatMasterType = (type) => {
  return type.toLowerCase().replace(/\s/g, "");
};
